<template>
    <span class="text-left">
        <button type="button" class="btn btn-outline-primary btn-sm mb-2" data-toggle="tooltip" data-placement="top" title="Programar Retorno"
            @click="programar()">
            <i class="fas fa-undo-alt"></i>
        </button>

        <!-- Modal -->
        <div class="modal fade" id="programarRetornoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="retorno">
                    <div class="modal-header">
                        <h5 class="modal-title">Programar Retorno</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    placeholder="Selecione o procedimento..."
                                    label="Procedimento"
                                    type="autocomplete" 
                                    service="procedimentos.index"
                                    optionsMode="aql"
                                    optionsName="procedimentos.index" 
                                    optionsData="id_procedimento" 
                                    optionsDisplay="search"
                                    required
                                    :validate="validate"
                                    v-model="retorno.id_procedimento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tempo"
                                    type="number"
                                    v-model="tempo" />
                            </div>
                            
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Referência de Tempo"
                                    type="select"
                                    :optionsList="[
                                        { id: 'days', search: 'dia(s)' },
                                        { id: 'weeks', search: 'semana(s)' },
                                        { id: 'months', search: 'mes(es)' },
                                        { id: 'years', search: 'ano(s)' },
                                    ]"
                                    optionsData="id"
                                    v-model="tipo_tempo" />
                            </div>
                        </div>

                        <div class="my-3 d-flex flex-column">
                            <button type="button" class="btn btn-sm btn-outline-primary" :disabled="!tempo || !tipo_tempo" @click="definir_data()">Definir Data</button>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Retornar em"
                                    type="date"
                                    rows="3"
                                    required
                                    :validate="validate"
                                    v-model="retorno.dt_retorno" />
                            </div>
                        </div>

                        <div v-if="retorno.dt_retorno" class="d-flex justify-content-between mb-3">

                            <div class="small text-muted">
                                {{ getHumanDay(retorno.dt_retorno) }}
                            </div>

                            <div class="small text-muted">
                                {{ getHumanDuration(retorno.dt_retorno) }}
                            </div>

                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    v-model="retorno.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </span>    
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: null, 
            retorno: null, 
            tipo_tempo: 'months',
            tempo: "", 
            validate: false,
        };
    },

    props: ['id_atendimento', 'id_procedimento'],

    components: { 
        AzInput, 
        AzSubmit,
    },

    methods: { 
        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
            else
                return moment
                .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
                .humanize(true);
        },

        definir_data () { 
            this.retorno.dt_retorno = moment(this.$util.hoje()).add(this.tempo, this.tipo_tempo).format('YYYY-MM-DD')

        },

        programar () { 
            this.validate = false; 
            this.retorno = null;

            this.$nextTick(() => { 
                this.retorno = { 
                    id_atendimento: this.id_atendimento, 
                    id_procedimento: this.id_procedimento,
                    dt_retorno: "", 
                    st_observacoes: "", 
                };
    
                $('#programarRetornoModal').modal('show');
            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'retorno_atendimentos',
                func: 'store',
                dados: this.retorno, 
                modal: 'programarRetornoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>